import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryService } from '../../appshared/masters/category/category.service';
import { ItemService } from '../../appshared/invoice/item/item.service';
import { AppLoaderService } from '../service/app-loader/app-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from '../../appshared/invoice/cart.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { ItemModule, ViewItem } from '../../appshared/invoice/item/item.module';
import { CategoryModule } from '../../appshared/masters/category/category.module';

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss']
})
export class ItemsComponent {

    public SelectedLanguage: string = "en";
    CategoryName = "";
    Type = "";
    public dataSourceItems = new MatTableDataSource<ItemModule>();
    currentDate = new Date();
    ComID: number = 2;
    public apiURL: string = "";

    constructor(
        public router: Router, private serv: CategoryService, private route: ActivatedRoute, private servItem: ItemService, private loader: AppLoaderService, public translate: TranslateService,

        private cartService: CartService, private toastr: ToastrService
    ) {
        if (this.translate.currentLang != undefined) {

            this.SelectedLanguage = this.translate.currentLang;
        }

    }


    ngOnInit(): void {

        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';

        this.route.params.subscribe(params => {
            if (params['Type'] != "NaN") {
                this.Type = params['Type'];
                
            }
            else {
                this.Type = "";
                this.CategoryName = "";
            }
        });

        if (this.Type == "new-collection") {
            this.CategoryName = "New_Collection";
            this.fillItemsNewArrival();
        }
        else if (this.Type == "most-sales") {
            this.CategoryName = "Most_Sales";
            this.fillItemsMostSales();
        }
        else if (this.Type == "offers") {
            this.CategoryName = "Offers";
            this.fillItemsOffer();
        }
        

        if (this.translate.currentLang != undefined) {
            this.SelectedLanguage = this.translate.currentLang;
        }
    }

    fillItemsNewArrival() {

        this.servItem.getServiceNewArrival(this.ComID)
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);
                }

                this.dataSourceItems.data = res;

            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    fillItemsMostSales() {
        //    this.loader.open();
        // getServiceNewArrival -----> (for test only)
        this.servItem.getServiceBestSeller(this.ComID)
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);
                }

                this.dataSourceItems.data = res;


            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    fillItemsOffer() {
        //    this.loader.open();
        this.servItem.getServiceDiscount(this.ComID)
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);
                }

                this.dataSourceItems.data = res;


            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    onClickItem(ItemId: number) {
        this.router.navigate(['product-details', { ItemId: ItemId }]);
    }

    addToCart(itemM: ItemModule) {


        this.loader.open();

        var price = itemM.salesPrice;
        if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
            price = itemM.webDiscountAmount;
        }


        var product: ViewItem = {


            inItemID: itemM.inItemID,
            name: itemM.webNameEn,
            nameAr: itemM.webNameAr,
            salesPrice: itemM.salesPrice,
            barcode: itemM.barcode,
            inCategoryID: itemM.inCategoryID,
            description: itemM.description,
            inUnitID: itemM.inUnitID,
            photoPath: itemM.photoPath,
            itemCode: itemM.itemCode,
            unitName: itemM.unitName,
            systemCode: itemM.systemCode,
            categoryNameAr: itemM.categoryNameAr,
            descriptionAr: itemM.descriptionAr,
            categoryName: itemM.categoryName,

            saleTaxPercentage: itemM.saleTaxPercentage,
            isViewWeb: itemM.isViewWeb,
            webDiscountFromDate: itemM.webDiscountFromDate,
            webDiscountToDate: itemM.webDiscountToDate,
            webDiscountAmount: itemM.webDiscountAmount,
            activateWebDiscount: itemM.activateWebDiscount,
            unitNameAr: itemM.unitNameAr,
            webDiscountPercentage: itemM.webDiscountPercentage,
            wholesalePrice: itemM.webDiscountPercentage,

            cartQuantity: 1,
            cartPrice: price

        };



        this.cartService.addToCart(product, 1);

        this.loader.close();

        var transR = this.translate.instant('Your_product_added_to_the_cart');
        this.toastr.success(transR, '');
        
    }

    onPageClick(event) {
        window.scroll(0, 0);

        this.currPages = event;
    }

    currPages: number = 1;

}
